module.exports = __webpack_public_path__ + "img/card-header.ffe642cd.png";